import React from 'react'


function Pricing() {
    return (
        <div className='container p-5 my-5'>
            <div className='row'>
                <div className='col-6'>
                    <h3>Unbeatable pricing</h3>
                    <p>We pioneered the concept of discount broking and price<br></br> transparency in India. Flat fees and no hidden charges.</p>
                    <a href='' style={{ textDecoration: "none" }} >See pricing</a>
                    <i class="fa fa-long-arrow-right" style={{ color: "blue", fontSize: '12px' }} aria-hidden="true"></i>
                </div>
                {/* <div className='col-2'></div> */}
                <div className='col-1'>
                    <img src='media/pricing-0.svg' style={{width: "150px"}} />
                </div>
                <div className='col-1 mt-5'>
                    <span style={{fontSize: "12px"}} >Free account opening</span>
                </div>
                <div className='col-1'>
                    <img src='media/pricing-0.svg' style={{width: "150px"}}  />
                </div>
                <div className='col-1 mt-5'>
                    <span  style={{fontSize: "12px"}} >Free equity delivery and direct mutual funds</span>
                </div>
                <div className='col-1'>
                    <img src='media/pricing-20.svg' style={{width: "150px"}}  />
                </div>
                <div className='col-1 mt-5'>
                    <span  style={{fontSize: "12px"}} >Intraday and F&O</span>
                </div>
            </div>
        </div>
    );
}

export default Pricing;